module.exports = __webpack_public_path__ + "img/svg/mobile-footer-menu-separator.9cf3643af8d2ebecafa045a2e5592756.svg";